export class RelacionamentoEntidade {
    public Email: string;
    public Assunto: string;
    public Mensagem: string;
}
